import {
  ImageModel,
  RichtextModel,
  SplitModel,
} from "@courses-pm2/api/src/ts/models";
import { Engine } from "@courses-pm2/api/src/ts/utils";

import { parseCaptionedContentElement } from "../parseCaptionedContentElement";
import { parseImage } from "./parseImage";
import { parseRichtext } from "./parseRichtext";

/**
 * Helper that parses <Split /> elements in the response from the pm2 backend.
 */
export async function parseSplit({
  node,
  portalId,
  engine,
}: {
  node: Element;
  portalId: string;
  engine?: Engine;
}): Promise<SplitModel | undefined> {
  // Announce that a model has been identified if possible
  if (engine) {
    engine.announce(SplitModel);
    engine.announce(ImageModel);
    engine.announce(RichtextModel);
  }

  const baseData = parseCaptionedContentElement(node);

  const image = await parseImage({ node, portalId, engine });
  const text = await parseRichtext({
    node,
    portalId,
    engine,
    nested: false,
    textNodeName: "Text",
    solid: true,
  });

  if (!text) {
    return undefined;
  }

  // @ts-expect-error We forcibly adapt to the split format
  text.title = node.getAttribute("title");
  // @ts-expect-error We forcibly adapt to the split format
  text.caption = undefined;

  const layout = (() => {
    switch (node.getAttribute("imageposition")) {
      case "first":
        return "image-text";

      case "last":
        return "text-image";

      default:
        console.warn(
          "parseSplitComponent(): Failed to parse imageposition correctly",
          node,
        );
        return "image-text";
    }
  })();

  return new SplitModel({
    engine,
    portalId,

    options: {
      layout,
      withGraphic: node.getAttribute("graphics") === "true",
      allowCrop: node.getAttribute("imageheight") === "crop",
    },

    image,
    text,

    ...baseData,
  });
}
